export default {
  hasInitialData: false,
  errors: []
}



// WEBPACK FOOTER //
// ./src/store/state.js